// TEMPORARY: used only by pages/Admin/DbChecks. Remove together with it.
import BaseApi from "./baseApi"

const API_URL = process.env.REACT_APP_API_URL

class DbChecksApi extends BaseApi {
  runCheck(checkId, token) {
    return this.fetchData({
      url: `${API_URL}/dashboard/db-checks/run`,
      method: "POST",
      data: { check_id: checkId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
  }
}

export default new DbChecksApi()
